export default __webpack_public_path__ + "media/images/mailer-new/welcome/purple-extra-soft-spacer-672b073d1b6517228416947eec0eb9ad.png";